import styled from 'styled-components';

export const AntSwitch = (ComponentName: any) => styled(ComponentName)`
  &.ant-switch-checked {
    border-color: #CF1E91;
    background-color: #CF1E91;
  }
`;
